import template from './displayTemplate.html';
import controller from './displayTemplate.controller';
import './displayTemplate.scss';

let displayTemplateComponent = {
  bindings: {
    template: '<',
    templateBlocks: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default displayTemplateComponent;



// WEBPACK FOOTER //
// ./client/app/components/displayTemplate/displayTemplate.component.js